module.exports = __webpack_public_path__ + "img/delete-icon.1b909175.svg";